import { Box, Tabs, Tab, IconButton, SpeedDialAction, SpeedDial, Chip } from "@mui/material";
import { useEffect } from "react";
import { useContext } from "react";
import { useCallback, useMemo, useState } from "react";

import Draggable from "react-draggable";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
	ActiveEnrollmentStatus,
	ActiveIntercityEnrollmentStatus,
	EnrollmentSchema,
	IntercityEnrollmentStatus,
	OpenEnrollmentByIntercityPlan,
	OpenEnrollmentByPlan,
	Status,
	VEBEnrollmentStatus
} from "../../../../types/enrollment.types";
import { OverallPremiums } from "../../../../types/overallPremiums.types";
import { GroupEnrollmentContext, PaycheckContext, ThemeContext, AuthContext } from "../../../../contexts";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { HealthPlanBrochure } from "../../../../assets";

import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import EnrollmentTabLabel from "../enrollmentTabLabel/EnrollmentTabLabel";

import DownloadIcon from "@mui/icons-material/Download";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";

import { api } from "../../../../utils/api";
import { Member } from "../../../../types/employee.types";
import { Plan } from "../../../../types/plan.types";
import { OpenEnrollment } from "../../../../types/openEnrollment.types";
import { Plans, IntercityPlanTab } from "../../../../types/components/enrollmentProps.types";
import { numberToDollarStr } from "../../../../utils/commonFunctions/dollar";
import EnrollmentAcknowledgement from "../enrollmentAcknowledgement/EnrollmentAcknowledgement";
import { Brochure } from "../../../../assets";
import downloadFile from "../../../../utils/commonFunctions/downloadFile";
import PlanAcknowledgement from "../plans/planAknowledgement/PlanAknowledgement";
import { trackPromise } from "react-promise-tracker";
import {
	IntercityHealthPlanBranding,
	IntercityGLTDPlanBranding,
	IntercityFlexMedPlanBranding,
	IntercityFlexCarePlanBranding,
	IntercityGLIFreePlanBranding,
	IntercityGLIOptionalPlanBranding,
	IntercityGLTDForm,
	IntercityPlanAcknowledgement,
	IntercityHealthPlanForm
} from "../..";
import IntercityHealthPlanAcknowledgement from "./intercityPlans/healthPlan/intercityHealthPlanAcknowledgement/IntercityHealthPlanAcknowledgement";
import initCapitalize from "../../../../utils/commonFunctions/initCapitalize";
import { dollarize } from "../../../../utils/commonFunctions/dollarize";

import "./intercityEnrollment.css";
import { ICICoreEnrollmentArray } from "../../../../constants/ICICoreEnrollmentsNext";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.action.hover
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14
	}
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(even)": {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0
	}
}));

function a11yProps(index: number) {
	return {
		id: `vertical-tab-${index}`,
		"aria-controls": `vertical-tabpanel-${index}`
	};
}

const IntercityEnrollment = (): JSX.Element => {
	const [activeTab, setActiveTab] = useState<string>();
	const [activeEnrollmentStatus, setActiveEnrollmentStatus] = useState<ActiveIntercityEnrollmentStatus>();
	const [visitedPlans, setVisitedPlans] = useState<string[]>([]);
	const [enrollments, setEnrollments] = useState<EnrollmentSchema[]>([]);
	const [VEBEnrollmentStatus, setVEBEnrollmentStatus] = useState<VEBEnrollmentStatus | null>(null);
	const [openEnrollmentByPlan, setOpenEnrollmentByPlan] = useState<OpenEnrollmentByIntercityPlan | null>(null);
	const [hasSetPlanTabs, setHasSetPlanTabs] = useState<boolean>(false);
	const { currentEnrollment, deleteCurrentEnrollment } = useContext(GroupEnrollmentContext);
	const [planTabs, setPlanTabs] = useState<IntercityPlanTab[]>([
		{
			plan_name: "Health Plan"
		},
		{
			plan_name: "Flex Med"
		},
		{
			plan_name: "Flex Care"
		},
		{
			plan_name: "Group Long Term Disability"
		},
		{
			plan_name: "Group Life Insurance(Free)"
		},
		{
			plan_name: "Group Life Insurance(Optional)"
		}
	]);
	const [openEnrollments, setOpenEnrollments] = useState<
		{
			open_enrollment: OpenEnrollment & {
				plan: Plan;
			};
		}[]
	>([]);
	const [enrollmentStatus, setEnrollmentStatus] = useState<IntercityEnrollmentStatus | null>(null);
	const [value, setValue] = useState<string>();
	const [overallPremiums, setOverallPremiums] = useState<OverallPremiums[]>([]);
	const [dependents, setDependents] = useState<Member[]>([]);
	const [totalPremium, setTotalPremium] = useState(0.0);
	const location = useLocation();
	const { theme } = useContext(ThemeContext);
	const { member } = useContext(AuthContext);
	const { paycheck } = useContext(PaycheckContext);
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const height = screen.height;
	const [showOverallPremium, setShowOverallPremium] = useState(true);

	const history = useHistory();

	const overallPremiumChipColor = {
		SUBMIITED: {
			background_color: "#d5e5d9",
			text_color: "#4cb464"
		},
		CURRENT: {
			background_color: "#f0ebc5",
			text_color: "#c9b30c"
		},
		WAIVED: {
			background_color: "#f7e9e9",
			text_color: "#eb2a2a"
		}
	};
	const speedDialActions = [
		// eslint-disable-next-line prettier/prettier
		{
			name: <div className="tooltip-speed-dial">Download&nbsp;Brochure</div>,
			icon: <DownloadIcon />,
			actionName: "download_brochure"
		},
		{
			name: <div className="tooltip-speed-dial">Email&nbsp;Brochure</div>,
			icon: <AttachEmailIcon />,
			actionName: "email_brochure"
		}
	];
	const [speedDialOpen, setSpeedDialOpen] = useState(true);

	const handleOpen = () => setSpeedDialOpen(true);

	const handleClose = () => setSpeedDialOpen(false);

	const handleChange = useCallback(
		(event: React.SyntheticEvent<Element, Event>, newValue: string) => {
			setActiveTab(newValue);
			setValue(newValue);
			deleteCurrentEnrollment();

			ICICoreEnrollmentArray.forEach((element, index) => {
				if (newValue === element) {
					const selectedRange = ICICoreEnrollmentArray.slice(0, index + 1);
					setVisitedPlans([...selectedRange]);
				}
			});
		},
		[deleteCurrentEnrollment]
	);

	// console.log("__visitedPlans", visitedPlans);

	const initialVistedPlans = useCallback(() => {
		setVisitedPlans(["Health Plan"]);
	}, []);

	const getEnrollmentStatus = useCallback(
		(
			planName: string,
			enrollments: any,
			openEnrollments: {
				open_enrollment: OpenEnrollment & {
					plan: Plan;
				};
			}[]
		): {
			status: {
				enrollment: Status;
				openEnrollment: Status;
			};
			openEnrollmentByPlanItem: {
				[key: string]: OpenEnrollment & {
					plan: Plan;
				};
			} | null;
		} => {
			let enrollment: Status = "CLOSED";

			for (let enrollmentIdx = 0; enrollmentIdx < enrollments.length; enrollmentIdx++) {
				if (enrollments[enrollmentIdx]?.plan_name === planName) {
					enrollment = enrollments[enrollmentIdx].enrollment_status;
					break;
				}
			}
			let openEnrollment: Status = "CLOSED";
			let openEnrollmentByPlanItem: {
				[key: string]: OpenEnrollment & {
					plan: Plan;
				};
			} | null = null;
			for (let openEnrollmentIdx = 0; openEnrollmentIdx < openEnrollments.length; openEnrollmentIdx++) {
				if (openEnrollments[openEnrollmentIdx].open_enrollment.plan.plan_name === planName) {
					openEnrollment = "OPENED";

					openEnrollmentByPlanItem = {
						[planName]: openEnrollments[openEnrollmentIdx].open_enrollment
					};
					break;
				}
			}
			return {
				status: {
					enrollment,
					openEnrollment
				},
				openEnrollmentByPlanItem
			};
		},
		[]
	);

	const getActiveEnrollmentStatus = useCallback((activeEnrollments: EnrollmentSchema[]) => {
		const _activeEnrollmentStatus = {
			"Health Plan": false,
			"Flex Med": false,
			"Flex Care": false,
			"Group Long Term Disability": false,
			"Group Life Insurance(Free)": false,
			"Group Life Insurance(Optional)": false
		};
		Object.entries(_activeEnrollmentStatus).forEach(([planName, value], index) => {
			activeEnrollments.forEach((activeEnrollment: EnrollmentSchema) => {
				const { enrollment_status, plan_name } = activeEnrollment;
				if (plan_name === planName) {
					_activeEnrollmentStatus[planName as keyof ActiveIntercityEnrollmentStatus] = true;
				}
			});
		});
		setActiveEnrollmentStatus(Object.assign({}, _activeEnrollmentStatus));
	}, []);

	const getEnrollmentInitData = useCallback(
		async (resetPlanTabs = true) => {
			const { openEnrollments, dependents, enrollments, activeEnrollments } = await trackPromise(
				api.pages.getEnrollmentInitData()
			);
			getActiveEnrollmentStatus(activeEnrollments);
			setOpenEnrollments(Object.assign([], openEnrollments));
			setEnrollments(Object.assign([], enrollments));
			let _enrollmentStatus: IntercityEnrollmentStatus = {
				"Health Plan": {
					enrollment: "CLOSED",
					openEnrollment: "CLOSED"
				},
				"Flex Med": {
					enrollment: "CLOSED",
					openEnrollment: "CLOSED"
				},
				"Flex Care": {
					enrollment: "CLOSED",
					openEnrollment: "CLOSED"
				},
				"Group Long Term Disability": {
					enrollment: "CLOSED",
					openEnrollment: "CLOSED"
				},
				"Group Life Insurance(Free)": {
					enrollment: "CLOSED",
					openEnrollment: "CLOSED"
				},
				"Group Life Insurance(Optional)": {
					enrollment: "CLOSED",
					openEnrollment: "CLOSED"
				}
			};
			// const _enrollments = [
			// 	{ plan: { plan_name: "Clinic Card" }, status: "ACTIVE" },
			// 	// { plan: { plan_name: "Health Plan" }, status: "WAIVED" },
			// 	{ plan: { plan_name: "Group Short Term Disability" }, status: "WAIVED" },
			// 	{ plan: { plan_name: "KSOP" }, status: "WAIVED" }
			// ];
			let _openEnrollmentByPlan: OpenEnrollmentByIntercityPlan = {
				"Health Plan": null,
				"Flex Med": null,
				"Flex Care": null,
				"Group Long Term Disability": null,
				"Group Life Insurance(Free)": null,
				"Group Life Insurance(Optional)": null
			};
			Object.entries(_enrollmentStatus).forEach(([planName], index) => {
				const { status, openEnrollmentByPlanItem } = getEnrollmentStatus(
					planName,
					enrollments,
					openEnrollments
				);
				_enrollmentStatus = { ..._enrollmentStatus, [planName]: status };
				if (openEnrollmentByPlanItem !== null) {
					_openEnrollmentByPlan = {
						..._openEnrollmentByPlan,
						...openEnrollmentByPlanItem
					};
				}
			});
			setOpenEnrollmentByPlan(Object.assign({}, _openEnrollmentByPlan));
			setEnrollmentStatus(Object.assign({}, _enrollmentStatus));
			setDependents(Object.assign([], dependents));
			if (resetPlanTabs === false) {
				return;
			}
			// if (paycheck?.employee_class === "FT - Full Time") {
			// 	const _planTab: IntercityPlanTab = { plan_name: "Health Plan" };

			// 	setPlanTabs((prevPlanTabs: IntercityPlanTab[]) => Object.assign([], [_planTab, ...prevPlanTabs]));
			// }
			// else if (paycheck?.employee_class === "PT - Part Time") {
			// 	const _planTab: IntercityPlanTab = { plan_name: "Clinic Card" };

			// 	setPlanTabs((prevPlanTabs: IntercityPlanTab[]) => Object.assign([], [_planTab, ...prevPlanTabs]));
			// } else if (paycheck?.employee_class === "PTIN - Part Time Insurance Eligible") {
			// 	const _planTabs: IntercityPlanTab[] = [{ plan_name: "Health Plan" }, { plan_name: "Clinic Card" }];
			// 	setPlanTabs((prevPlanTabs: IntercityPlanTab[]) => Object.assign([], [..._planTabs, ...prevPlanTabs]));
			// }
			setHasSetPlanTabs(true);
		},
		[getActiveEnrollmentStatus, getEnrollmentStatus]
	);

	const handleOverallPremiumClick = () => {
		setShowOverallPremium((prevShowOverallPremium: boolean) => !prevShowOverallPremium);
	};

	const getOverallPremium = useCallback(() => {
		const _overallPremiums: any[] = [];
		let submittedEnrollments: any[] = [];
		let waivedEnrollments: any[] = [];
		const _activeEnrollmentsPlanName: any[] = [];
		const _overallPremiumsPayload: any[] = [];

		submittedEnrollments = enrollments.filter((eachEnrollment: any) => {
			return eachEnrollment.enrollment_status === "SUBMITTED";
		});
		submittedEnrollments.forEach((submittedEnrollment: any) => {
			// _activeEnrollmentsPlanName.push(submittedEnrollment.base_plan_name);
			_overallPremiumsPayload.push(submittedEnrollment);
		});

		waivedEnrollments = enrollments.filter((eachEnrollment: any) => {
			return eachEnrollment.enrollment_status === "WAIVED";
		});
		const pushedWaivedPlanNames: string[] = [];
		waivedEnrollments.forEach((waivedEnrollment: any) => {
			const { base_plan_name } = waivedEnrollment;
			if (
				_activeEnrollmentsPlanName.includes(base_plan_name) === false &&
				pushedWaivedPlanNames.includes(base_plan_name) === false
			) {
				_overallPremiumsPayload.push(waivedEnrollment);
				pushedWaivedPlanNames.push(base_plan_name);
			}
		});

		let _totalPremium = 0;
		_overallPremiumsPayload.map((enrollment: EnrollmentSchema) => {
			const { base_plan_name, enrollment_status, total_premium } = enrollment;
			if (base_plan_name !== currentEnrollment?.plan_name) {
				_overallPremiums.push({
					plan_name: base_plan_name,
					premium_amount: total_premium,
					status: enrollment_status
				});
				_totalPremium += total_premium;
			}
		});
		setTotalPremium(_totalPremium);
		setOverallPremiums(Object.assign([], _overallPremiums));
	}, [currentEnrollment, enrollments]);

	const handleDownloadBrochure = useCallback(() => {
		const step = urlSearchParams.get("step");
		switch (step) {
			case "Health Plan":
				downloadFile(HealthPlanBrochure, "Health_Plan_Brochure");
				break;
			case "Flex Med":
				downloadFile(HealthPlanBrochure, "Flex_Med_Brochure");
				break;
			case "Flex Care":
				downloadFile(HealthPlanBrochure, "Flex_Care_Brochure");
				break;
			case "Group Long Term Disability":
				downloadFile(HealthPlanBrochure, "Group_Long_Term_Disability_Brochure");
				break;
			case "Group Life Insurance(Free)":
				downloadFile(HealthPlanBrochure, "Group_Life_Insurance(Free)_Brochure");
				break;
			case "Group Life Insurance(Optional)":
				downloadFile(HealthPlanBrochure, "Group_Life_Insurance(Optional)_Brochure");
				break;

			default:
				downloadFile(Brochure, "Plan_Brochure");
		}
	}, [urlSearchParams]);

	const handleEmailBrochurePost = useCallback(async () => {
		//if (!openEnrollmentByPlan) return;
		const step = urlSearchParams.get("step");
		if (!openEnrollmentByPlan || !step || !member) {
			return;
		}
		if (!openEnrollmentByPlan[step as keyof OpenEnrollmentByIntercityPlan]?.plan.plan_name) {
			alert("The plan has not been opened yet");
			return;
		}
		if (!openEnrollmentByPlan[step as keyof OpenEnrollmentByIntercityPlan]?.plan.document?.filename) {
			alert("No brochure is attached. Please contact your administrator");
			return;
		}
		const payload = {
			email: member.email,
			group_number: member.group_number,
			filename: openEnrollmentByPlan[step as keyof OpenEnrollmentByIntercityPlan]?.plan.document?.filename,
			plan_code: openEnrollmentByPlan[step as keyof OpenEnrollmentByIntercityPlan]?.plan.plan_code,
			plan_name: openEnrollmentByPlan[step as keyof OpenEnrollmentByIntercityPlan]?.plan.plan_name,
			subject: "Dear Enroller, Your plan brochure  "
		};
		// console.log("Plan Payload", payload);
		const response = await trackPromise(api.email.emailBrochure(payload));

		if (response === true) {
			alert("Email brochure has been successfully sent");
		}
	}, [openEnrollmentByPlan, urlSearchParams, member]);

	const renderPlan = useCallback(() => {
		if (enrollmentStatus === null || openEnrollmentByPlan === null || activeEnrollmentStatus === undefined) {
			return;
		}

		const step = urlSearchParams.get("step");
		const stage = urlSearchParams.get("stage");
		switch (step) {
			case "Health Plan": {
				if (stage === "0") {
					if (
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							enrollmentStatus["Health Plan"].enrollment
						) &&
						openEnrollments &&
						enrollments
					) {
						return (
							<IntercityHealthPlanAcknowledgement
								openEnrollments={openEnrollments}
								enrollments={enrollments}
								planName={"Health Plan"}
							/>
						);
					} else {
						return (
							<IntercityHealthPlanBranding
								status={enrollmentStatus["Health Plan"]}
								dependents={dependents}
								openEnrollment={openEnrollmentByPlan["Health Plan"]}
								getEnrollmentInitData={getEnrollmentInitData}
								isActiveEnrollment={
									activeEnrollmentStatus["Health Plan" as keyof ActiveIntercityEnrollmentStatus]
								}
							/>
						);
					}
				} else if (stage === "1") {
					if (!["ACTIVE", "REJECTED"].includes(enrollmentStatus["Health Plan"].enrollment)) {
						return (
							<IntercityHealthPlanForm
								dependents={dependents}
								openEnrollment={openEnrollmentByPlan["Health Plan"]}
								getEnrollmentInitData={getEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<IntercityHealthPlanAcknowledgement
							openEnrollments={openEnrollments}
							enrollments={enrollments}
							planName={"Health Plan"}
						/>
					);
				}
				break;
			}
			case "Group Long Term Disability": {
				if (stage === "0") {
					if (
						["SUBMITTED"].includes(enrollmentStatus["Group Long Term Disability"].enrollment) &&
						["CLOSED"].includes(enrollmentStatus["Group Long Term Disability"].openEnrollment)
					) {
						// No Enroll Button - When Only HP O.E Opened and GLTD is submitted via HP
						return (
							<IntercityHealthPlanAcknowledgement
								openEnrollments={openEnrollments}
								enrollments={enrollments}
								planName={"Health Plan"}
								showEnrollButton={false}
							/>
						);
					} else if (
						["SUBMITTED"].includes(enrollmentStatus["Group Long Term Disability"].enrollment) &&
						["OPENED"].includes(enrollmentStatus["Health Plan"].openEnrollment) &&
						["SUBMITTED"].includes(enrollmentStatus["Health Plan"].enrollment)
					) {
						// No Enroll Button - When GLTD is Opened and Submitted first via GLTD. After that HP is Opened and Submitted.
						return (
							<IntercityHealthPlanAcknowledgement
								openEnrollments={openEnrollments}
								enrollments={enrollments}
								planName={"Health Plan"}
								showEnrollButton={false}
							/>
						);
					} else if (
						["SUBMITTED"].includes(enrollmentStatus["Group Long Term Disability"].enrollment) &&
						["OPENED"].includes(enrollmentStatus["Health Plan"].openEnrollment) &&
						["CLOSED"].includes(enrollmentStatus["Health Plan"].enrollment)
					) {
						// No Enroll Button - When GLTD is Opened and Submitted first via GLTD. After that HP is Opened.
						return (
							<IntercityPlanAcknowledgement
								openEnrollments={openEnrollments}
								enrollments={enrollments}
								planName={"Group Long Term Disability"}
								showEnrollButton={false}
							/>
						);
					} else if (
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							enrollmentStatus["Group Long Term Disability"].enrollment
						) &&
						openEnrollments &&
						enrollments
					) {
						return (
							<IntercityPlanAcknowledgement
								openEnrollments={openEnrollments}
								enrollments={enrollments}
								planName={"Group Long Term Disability"}
							/>
						);
					} else {
						return (
							<IntercityGLTDPlanBranding
								status={enrollmentStatus["Group Long Term Disability"]}
								dependents={dependents}
								openEnrollment={openEnrollmentByPlan["Group Long Term Disability"]}
								getEnrollmentInitData={getEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "1") {
					if (!["ACTIVE", "REJECTED"].includes(enrollmentStatus["Group Long Term Disability"].enrollment)) {
						return (
							<IntercityGLTDForm
								dependents={dependents}
								openEnrollment={openEnrollmentByPlan["Group Long Term Disability"]}
								getEnrollmentInitData={getEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "2") {
					return (
						<IntercityPlanAcknowledgement
							openEnrollments={openEnrollments}
							enrollments={enrollments}
							planName={"Group Short Term Disability"}
						/>
					);
				}
				break;
			}
			case "Flex Med": {
				if (stage === "0") {
					if (
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							enrollmentStatus["Flex Med"].enrollment
						) &&
						openEnrollments &&
						enrollments
					) {
						return (
							<IntercityPlanAcknowledgement
								openEnrollments={openEnrollments}
								enrollments={enrollments}
								planName={"Flex Med"}
							/>
						);
					} else {
						return (
							<IntercityFlexMedPlanBranding
								status={enrollmentStatus["Flex Med"]}
								dependents={dependents}
								openEnrollment={openEnrollmentByPlan["Flex Med"]}
								getEnrollmentInitData={getEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "1") {
					// if (!["ACTIVE", "REJECTED"].includes(enrollmentStatus["Group Short Term Disability"].enrollment)) {
					// 	return (
					// 		<GstdForm
					// 			dependents={dependents}
					// 			openEnrollment={openEnrollmentByPlan["Group Short Term Disability"]}
					// 			getEnrollmentInitData={getEnrollmentInitData}
					// 		/>
					// 	);
					// }
				} else if (stage === "2") {
					return (
						<IntercityPlanAcknowledgement
							openEnrollments={openEnrollments}
							enrollments={enrollments}
							planName={"Group Short Term Disability"}
						/>
					);
				}
				break;
			}
			case "Flex Care": {
				if (stage === "0") {
					if (
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							enrollmentStatus["Flex Care"].enrollment
						) &&
						openEnrollments &&
						enrollments
					) {
						return (
							<IntercityPlanAcknowledgement
								openEnrollments={openEnrollments}
								enrollments={enrollments}
								planName={"Flex Care"}
							/>
						);
					} else {
						return (
							<IntercityFlexCarePlanBranding
								status={enrollmentStatus["Flex Care"]}
								dependents={dependents}
								openEnrollment={openEnrollmentByPlan["Flex Care"]}
								getEnrollmentInitData={getEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "1") {
					// if (!["ACTIVE", "REJECTED"].includes(enrollmentStatus["Group Short Term Disability"].enrollment)) {
					// 	return (
					// 		<GstdForm
					// 			dependents={dependents}
					// 			openEnrollment={openEnrollmentByPlan["Group Short Term Disability"]}
					// 			getEnrollmentInitData={getEnrollmentInitData}
					// 		/>
					// 	);
					// }
				} else if (stage === "2") {
					return (
						<IntercityPlanAcknowledgement
							openEnrollments={openEnrollments}
							enrollments={enrollments}
							planName={"Group Short Term Disability"}
						/>
					);
				}
				break;
			}
			case "Group Life Insurance(Free)": {
				if (stage === "0") {
					if (
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							enrollmentStatus["Group Life Insurance(Free)"].enrollment
						) &&
						openEnrollments &&
						enrollments
					) {
						return (
							<PlanAcknowledgement
								openEnrollments={openEnrollments}
								enrollments={enrollments}
								planName={"Group Life Insurance(Free)"}
							/>
						);
					} else {
						return (
							<IntercityGLIFreePlanBranding
								status={enrollmentStatus["Group Life Insurance(Free)"]}
								dependents={dependents}
								openEnrollment={openEnrollmentByPlan["Group Life Insurance(Free)"]}
								getEnrollmentInitData={getEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "1") {
					// if (!["ACTIVE", "REJECTED"].includes(enrollmentStatus["Group Short Term Disability"].enrollment)) {
					// 	return (
					// 		<GstdForm
					// 			dependents={dependents}
					// 			openEnrollment={openEnrollmentByPlan["Group Short Term Disability"]}
					// 			getEnrollmentInitData={getEnrollmentInitData}
					// 		/>
					// 	);
					// }
				} else if (stage === "2") {
					return (
						<IntercityPlanAcknowledgement
							openEnrollments={openEnrollments}
							enrollments={enrollments}
							planName={"Group Short Term Disability"}
						/>
					);
				}
				break;
			}
			case "Group Life Insurance(Optional)": {
				if (stage === "0") {
					if (
						["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED"].includes(
							enrollmentStatus["Group Life Insurance(Optional)"].enrollment
						) &&
						openEnrollments &&
						enrollments
					) {
						return (
							<PlanAcknowledgement
								openEnrollments={openEnrollments}
								enrollments={enrollments}
								planName={"Group Life Insurance(Optional)"}
							/>
						);
					} else {
						return (
							<IntercityGLIOptionalPlanBranding
								status={enrollmentStatus["Group Life Insurance(Optional)"]}
								dependents={dependents}
								openEnrollment={openEnrollmentByPlan["Group Life Insurance(Optional)"]}
								getEnrollmentInitData={getEnrollmentInitData}
							/>
						);
					}
				} else if (stage === "1") {
					// if (!["ACTIVE", "REJECTED"].includes(enrollmentStatus["Group Short Term Disability"].enrollment)) {
					// 	return (
					// 		<GstdForm
					// 			dependents={dependents}
					// 			openEnrollment={openEnrollmentByPlan["Group Short Term Disability"]}
					// 			getEnrollmentInitData={getEnrollmentInitData}
					// 		/>
					// 	);
					// }
				} else if (stage === "2") {
					return (
						<IntercityPlanAcknowledgement
							openEnrollments={openEnrollments}
							enrollments={enrollments}
							planName={"Group Short Term Disability"}
						/>
					);
				}
				break;
			}
		}
	}, [
		activeEnrollmentStatus,
		dependents,
		enrollmentStatus,
		enrollments,
		getEnrollmentInitData,
		openEnrollmentByPlan,
		openEnrollments,
		urlSearchParams
	]);

	useEffect(() => {
		getEnrollmentInitData(true);
		initialVistedPlans();
	}, [getEnrollmentInitData, initialVistedPlans]);

	useEffect(() => {
		getOverallPremium();
	}, [getOverallPremium, enrollments]);

	useEffect(() => {
		if (hasSetPlanTabs === true) {
			setActiveTab(planTabs[0].plan_name);
		}
	}, [hasSetPlanTabs, planTabs]);

	useEffect(() => {
		if (currentEnrollment) {
			const _overallPremiums: any[] = [];
			let _totalPremium = 0;
			enrollments.forEach((VEBEnrollment: EnrollmentSchema) => {
				const { base_plan_name, premium_amount, enrollment_status } = VEBEnrollment;
				if (base_plan_name !== currentEnrollment?.plan_name) {
					_overallPremiums.push({
						plan_name: base_plan_name,
						premium_amount: premium_amount,
						status: enrollment_status
					});
					_totalPremium += premium_amount;
				}
			});
			setTotalPremium(() => Number((_totalPremium + currentEnrollment.premium_amount).toFixed(2)));
		}
		// console.log("ue1111");
	}, [currentEnrollment, enrollments]);

	useEffect(() => {
		if (activeTab) {
			history.push("?step=" + activeTab + "&stage=0");
		}
	}, [activeTab, history]);

	//return <></>;
	return (
		<>
			<div className="enrollment">
				<Box
					className="box-container"
					sx={{
						flexGrow: 1,
						//bgcolor: "background.paper",
						display: "block",
						marginLeft: "-2rem"
					}}
				>
					<Tabs
						orientation="vertical"
						className="tabs-cotainer"
						// variant="scrollable"
						//variant="fullWidth"
						style={{
							// boxShadow:
							//"rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset",
							boxShadow: "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
							borderTopLeftRadius: 20,
							borderTopRightRadius: 20,
							borderBottomLeftRadius: 20,
							borderBottomRightRadius: 20,
							color: theme.primary_color
						}}
						TabIndicatorProps={{
							style: {
								color: theme.primary_color,
								backgroundColor: theme.primary_color
							}
						}}
						value={value}
						onChange={handleChange}
					>
						{enrollmentStatus &&
							activeEnrollmentStatus &&
							planTabs.map((planTab: IntercityPlanTab, index: number) => {
								const { plan_name } = planTab;
								return (
									<Tab
										key={index}
										className={
											activeTab == plan_name
												? visitedPlans.includes(plan_name)
													? "active-tab tracker"
													: "active-tab"
												: visitedPlans.includes(plan_name)
												? "active-tab tracker"
												: "active-tab"
										}
										style={{
											height: (height - 500) / planTabs.length,
											color: activeTab == plan_name ? theme.primary_color : undefined
										}}
										value={plan_name}
										label={
											enrollmentStatus[plan_name as keyof IntercityEnrollmentStatus]
												?.enrollment ? (
												<EnrollmentTabLabel
													planName={plan_name}
													// status={
													// 	["Health Plan"].includes(plan_name)
													// 		? "OPENED"
													// 		: enrollmentStatus[
													// 				plan_name as keyof IntercityEnrollmentStatus
													// 		  ].enrollment
													// }
													// status={
													// 	enrollmentStatus[plan_name as keyof IntercityEnrollmentStatus]
													// 		.enrollment
													// }
													// isOpenEnrollment={
													// 	["Health Plan"].includes(plan_name)
													// 		? true
													// 		: enrollmentStatus[
													// 				plan_name as keyof IntercityEnrollmentStatus
													// 		  ].openEnrollment === "OPENED"
													// 		? true
													// 		: false
													// }
													// isOpenEnrollment={
													// 	enrollmentStatus[plan_name as keyof IntercityEnrollmentStatus]
													// 		.openEnrollment === "OPENED"
													// 		? true
													// 		: false
													// }
													isActiveEnrollment={
														activeEnrollmentStatus[
															plan_name as keyof ActiveIntercityEnrollmentStatus
														]
													}
													carrier="Intercity"
													status={
														["Group Long Term Disability"].includes(plan_name) &&
														enrollmentStatus["Health Plan"].openEnrollment === "OPENED"
															? "CLOSED"
															: enrollmentStatus[
																	plan_name as keyof IntercityEnrollmentStatus
															  ].enrollment
													}
													isOpenEnrollment={
														["Group Long Term Disability"].includes(plan_name) &&
														enrollmentStatus["Health Plan"].openEnrollment === "OPENED"
															? false
															: enrollmentStatus[
																	plan_name as keyof IntercityEnrollmentStatus
															  ].openEnrollment === "OPENED"
															? true
															: false
													}
												/>
											) : null
										}
										{...a11yProps(0)}
									/>
								);
							})}
					</Tabs>
					<div className="form-container">{renderPlan()}</div>
				</Box>
				{showOverallPremium ? (
					<Draggable>
						<div className="draggable-premium-box">
							<div>
								<div
									className={"top-bar-expand"}
									style={{ backgroundColor: theme.button.background_color }}
								>
									<div className="header" style={{ color: theme.button.color }}>
										Overall Premium (Current OE)
									</div>
									<div className={"icon-expand"}>
										<IconButton onClick={handleOverallPremiumClick}>
											<KeyboardArrowRightIcon style={{ color: theme.button.color }} />
										</IconButton>
									</div>
								</div>
							</div>
							<div>
								<div
									style={{
										backgroundColor: "#e3e1e1",
										padding: "1rem",
										display: "flex",
										fontWeight: "bold",
										alignItems: "center",
										gap: "20%"
									}}
								>
									<div className="header" style={{ color: "#242424", flex: "1" }}>
										{/* <span>VEB</span> */}
										<span>Group&nbsp;Plan(s)</span>
									</div>

									<div className="header" style={{ fontSize: "1rem", marginLeft: "2rem", flex: "3" }}>
										Premium($)
									</div>
									<div
										className="header"
										style={{ color: "#242424", marginRight: "12rem", flex: "1" }}
									>
										Status
									</div>
								</div>
							</div>
							<TableContainer
								component={Paper}
								style={{ zIndex: 99999, maxHeight: "300px", overflowY: "auto" }}
							>
								<Table sx={{ minWidth: 300 }} aria-label="customized table">
									{/* <TableHead>
										<TableRow>
											<StyledTableCell>
												<span className="premium-table-header">Plan</span>
											</StyledTableCell>
											<StyledTableCell align="right">
												<span className="premium-table-header">Premium&nbsp;($)</span>
											</StyledTableCell>
											<StyledTableCell align="right">
												<span className="premium-table-header">Status</span>
											</StyledTableCell>
										</TableRow>
									</TableHead> */}
									<TableBody>
										{overallPremiums.map((overallPremium: OverallPremiums, index: number) => (
											<StyledTableRow key={index}>
												<StyledTableCell component="th" scope="row">
													{overallPremium.plan_name}
												</StyledTableCell>
												<StyledTableCell align="right">
													{overallPremium.premium_amount.toFixed(2)}
												</StyledTableCell>
												{overallPremium.status ? (
													<StyledTableCell align="right">
														<Chip
															label={initCapitalize(overallPremium.status)}
															style={{
																backgroundColor: `${
																	overallPremium.status === "SUBMITTED"
																		? overallPremiumChipColor.SUBMIITED
																				.background_color
																		: overallPremium.status === "WAIVED"
																		? overallPremiumChipColor.WAIVED
																				.background_color
																		: null
																}`,
																color: `${
																	overallPremium.status === "SUBMITTED"
																		? overallPremiumChipColor.SUBMIITED.text_color
																		: overallPremium.status === "WAIVED"
																		? overallPremiumChipColor.WAIVED.text_color
																		: null
																}`,
																fontWeight: "700"
															}}
														/>
													</StyledTableCell>
												) : null}
											</StyledTableRow>
										))}
										{currentEnrollment ? (
											<StyledTableRow>
												<StyledTableCell component="th" scope="row">
													{currentEnrollment.plan_name}
												</StyledTableCell>
												<StyledTableCell align="right">
													{currentEnrollment.premium_amount}
												</StyledTableCell>
												<StyledTableCell align="right">
													<Chip
														label={initCapitalize(currentEnrollment.status)}
														style={{
															backgroundColor:
																overallPremiumChipColor.CURRENT.background_color,
															color: overallPremiumChipColor.CURRENT.text_color,
															fontWeight: "700"
														}}
													/>
												</StyledTableCell>
											</StyledTableRow>
										) : null}
									</TableBody>
								</Table>
							</TableContainer>
							<div>
								<div
									style={{
										backgroundColor: "#e3e1e1",
										padding: "0.3rem",
										display: "flex",
										fontWeight: "bold",
										alignItems: "center",
										gap: "20%"
									}}
								>
									<div className="header" style={{ color: "#242424", marginLeft: "1rem" }}>
										TOTAL AMOUNT
									</div>

									<div className="show-premium" style={{ fontSize: "1.3rem" }}>
										{dollarize(Number(totalPremium.toFixed(2))) + (currentEnrollment ? "*" : "")}
									</div>
								</div>
							</div>
						</div>
					</Draggable>
				) : (
					<Draggable axis="y">
						<div className="draggable-premium-box">
							<div>
								<div className={"top-bar"} style={{ backgroundColor: theme.button.background_color }}>
									<div className="header" style={{ color: theme.button.color }}>
										Overall Amount
									</div>
									<div className={"icon"}>
										<IconButton onClick={handleOverallPremiumClick}>
											<KeyboardArrowRightIcon style={{ color: theme.button.color }} />
										</IconButton>
									</div>
								</div>
							</div>
						</div>
					</Draggable>
				)}
			</div>
			{urlSearchParams.get("step") !== "Christmas Club Election" ? (
				<SpeedDial
					ariaLabel="SpeedDial tooltip example"
					sx={{ position: "fixed", bottom: 16, right: 16 }}
					icon={<SpeedDialIcon />}
					onOpen={handleOpen}
					onClose={handleClose}
					open={speedDialOpen}
					style={{ fontSize: "10px" }}
					FabProps={{
						sx: {
							bgcolor: theme.primary_color,
							"&:hover": {
								bgcolor: theme.primary_color
							}
						}
					}}
				>
					{speedDialActions.map((speedDialAction: any) => (
						<SpeedDialAction
							key={speedDialAction.name}
							icon={speedDialAction.icon}
							tooltipTitle={speedDialAction.name}
							tooltipOpen
							onClick={
								speedDialAction.actionName === "email_brochure"
									? handleEmailBrochurePost
									: () => downloadFile(Brochure)
							}
							style={{ fontSize: "10px" }}
						/>
					))}
				</SpeedDial>
			) : null}
		</>
	);
};

export default IntercityEnrollment;
